// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"Slider_sliderWrapper__yknId"};